import React, { useEffect, useState } from "react";
import { useMessageContext } from "../../../context/MessageProvider";
import { useNavigate } from "react-router-dom";
import { CardContainer } from "../../../components/Card/CardContainer";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import { Col, Divider, Form, Modal, Row, Spin } from "antd";
import Button from "../../../components/Button/Button";
import { CODiscountStepOne } from "./CreateCODiscountStep/CODiscountStepOne";
import StepAntd from "../../../components/StepAntd/StepAntd";
import { CODiscountStepTwoShop } from "./CreateCODiscountStep/CODiscountStepTwoShop";
import { CODiscountStepThree } from "./CreateCODiscountStep/CODiscountStepThree";
import { CODiscountStepTwoProduct } from "./CreateCODiscountStep/CODiscountStepTwoProduct";
import {
  checkCoConflicts,
  createCoAttachment,
  createCoDiscoutList,
  deleteAttachmentById,
  getCoDiscountById,
  getCoDiscoutType,
  updateCoDiscoutList,
} from "../../../datasource/CODiscountDatasource";
import { useEffectOnce } from "react-use";
import Text from "../../../components/Text/Text";
import dayjs from "dayjs";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { getProductCategory, getProductGroup } from "../../../datasource/ProductDatasource";
import { getShopGroup } from "../../../datasource/ShopGroupDatasoure";
import { color } from "../../../resource";

export const CreateCODiscountList: React.FC = () => {
  const { messageApi } = useMessageContext();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const navigate = useNavigate();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isCreate = pathSplit[3] === "0";
  const id = pathSplit[3];
  const navigateType = pathSplit[pathSplit.length - 1];
  const [step, setStep] = useState(0);
  const [coType, setCoType] = useState([]);
  const [fileRef, setFileRef] = useState<any[]>([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [zoneList, setZoneList] = useState<any[]>([]);
  const [productGroup, setProductGroup] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [cusGroupList, setCusGroupList] = useState([]);

  const [errorMessage, setErrorMessage] = useState<any>({ step: undefined, message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();

  const fetchDataType = async () => {
    await getCoDiscoutType({
      company: profile?.company,
      page: 1,
      take: 999,
      status: true,
    }).then((res: any) => {
      setCoType(res.data);
    });
  };

  const fetchZone = async () => {
    await zoneDatasource.getAllZoneByCompany(profile.company).then((res) => {
      setZoneList(res);
    });
  };

  const fetchCustomerGroup = async () => {
    await getShopGroup({ page: 1, take: 999, company: profile.company, isActive: true }).then(
      (res) => {
        const mapData = res.responseData.data.map((group: any) => ({
          label: group.customerGroupName,
          value: group.customerGroupName,
          key: group.customerGroupName,
        }));
        setCusGroupList(mapData);
      },
    );
  };

  const fetchDataEdit = async () => {
    await getCoDiscountById(id).then(async (res: any) => {
      res?.attachmentFile &&
        setFileRef(
          res?.attachmentUrl ? [{ url: res?.attachmentUrl, name: res?.attachmentUrl }] : [],
        );
      form1.setFieldsValue({
        ...res,
        status: res?.status === "ACTIVE" ? true : false,
        startDate: res?.startDate ? dayjs(res.startDate) : null,
        endDate: res?.endDate ? dayjs(res.endDate) : null,
        startTime: res?.startDate ? dayjs(res.startDate) : null,
        endTime: res?.endDate ? dayjs(res.endDate) : null,
      });
      const mapCheckedShop = res?.coShops.map((item) => ({
        ...item,
        status: item.status === "ACTIVE" ? true : false,
        checked: false,
      }));
      const mapCheckedProduct = res?.coProducts.map((item) => ({
        coId: item.coId,
        coProductId: item.coProductId,
        discountMode: item.discountMode,
        discountValue: item.discountValue,
        productId: item.productId,
        productName: item.product.productName,
        commonName: item.product.commonName,
        productImage: item.product.productImage,
        productCodeNAV: item.product.productCodeNAV,
        productGroup: item.product.productGroup,
        marketPrice: item.product.marketPrice,
        packSize: item.product.packSize,
        qtySaleUnit: item.product.qtySaleUnit,
        saleUOM: item.product.saleUOM,
        saleUOMTH: item.product.saleUOMTH,
        baseUOM: item.baseUOM,
        productLocation: item.product.productLocation,
        checked: false,
      }));
      form2.setFieldsValue({
        products: mapCheckedProduct,
        searchProduct: mapCheckedProduct,
        shops: mapCheckedShop,
        searchShop: mapCheckedShop,
      });

      const cusComList = res?.coShops.map((item) => item.customerCompanyId);
      const productList = res?.coProducts.map((item) => item.productId);
      const checkDup = await checkCoDuplicate(
        profile.company,
        res?.type,
        res?.startDate,
        res?.endDate,
        cusComList,
        productList,
        res?.coId,
      );
      onCheckDuplicate(checkDup, form2);
    });
  };

  const fetchProductGroup = async () => {
    await getProductGroup(profile.company).then((res) => {
      setProductGroup(res?.responseData);
    });
  };

  const fetchProductCategory = async () => {
    await getProductCategory(profile.company).then((res) => {
      setProductCategory(res);
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchDataType();
    fetchProductGroup();
    fetchProductCategory();
    fetchCustomerGroup();
  });

  useEffect(() => {
    setLoading(true);
    if (id !== "0") {
      fetchDataEdit();
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [id]);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title={isCreate ? "สร้างส่วนลดดูแลราคา" : "แก้ไขส่วนลดดูแลราคา"}
        //onBack={() => setConfirmExitModal(true)}
        showBack
        extra={
          <>
            {step > 0 && (
              <StepAntd
                current={step}
                items={
                  form1.getFieldValue("type") === "BILL_PCT"
                    ? [
                        {
                          title: "รายละเอียด",
                        },
                        {
                          title: "ร้านค้า",
                        },
                        {
                          title: "ตรวจสอบ",
                        },
                      ]
                    : [
                        {
                          title: "รายละเอียด",
                        },
                        {
                          title: "สินค้า",
                        },
                        {
                          title: "ร้านค้า",
                        },
                        {
                          title: "ตรวจสอบ",
                        },
                      ]
                }
              />
            )}
          </>
        }
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "ส่วนลดทั้งหมด", path: "/newDiscountCo/coDiscountList" },
              ...(navigateType === "detail"
                ? [
                    {
                      text: "รายละเอียดส่วนลดดูแลราคา",
                      path: -1,
                    },
                  ]
                : []),
              {
                text: isCreate ? "สร้างส่วนลดดูแลราคา" : "แก้ไขส่วนลดดูแลราคา",
                path: -1,
              },
            ]}
          />
        }
      />
    );
  };

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <CODiscountStepOne
            form1={form1}
            form2={form2}
            typeList={coType}
            fileRef={fileRef}
            setFileRef={setFileRef}
          />
        );
      case 1:
        return (
          <CODiscountStepTwoProduct
            form1={form1}
            form2={form2}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            productGroup={productGroup}
            productCategory={productCategory}
          />
        );
      case 2:
        return (
          <CODiscountStepTwoShop
            form1={form1}
            form2={form2}
            zoneList={zoneList}
            cusGroupList={cusGroupList}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        );
      case 3:
        return <CODiscountStepThree form1={form1} form2={form2} typeList={coType} />;
      default:
        return null;
    }
  };

  const onPrev = () => {
    setErrorMessage({ step: undefined, message: "" });
    if (step === 2) {
      const dataForm1 = form1.getFieldsValue(true);
      setStep(dataForm1.type === "BILL_PCT" ? step - 2 : step - 1);
    } else {
      setStep(step - 1);
    }
  };

  const onNext = async () => {
    if (step === 0) {
      try {
        await form1.validateFields();
        const dataForm1 = form1.getFieldsValue(true);
        setStep(dataForm1.type === "BILL_PCT" ? step + 2 : step + 1);
      } catch (error) {
        console.log("error step 1", error);
      }
    } else if (step === 1) {
      const dataForm2 = form2.getFieldsValue(true);
      if (!dataForm2 || !dataForm2.products || dataForm2.products.length === 0) {
        setErrorMessage({ step: 1, message: "* กรุณาเพิ่มรายการสินค้า" });
        return;
      }
      try {
        await form2.validateFields();
        setStep(step + 1);
      } catch (error) {
        console.log("error step 2", error);
      }
    } else if (step === 2) {
      const dataForm2 = form2.getFieldsValue(true);
      if (!dataForm2 || !dataForm2.shops || dataForm2.shops.length === 0) {
        setErrorMessage({ step: 2, message: "* กรุณาเพิ่มรายการร้านค้า" });
        return;
      }
      try {
        await form2.validateFields();
        const dataForm2 = form2.getFieldsValue(true);

        setStep(step + 1);
      } catch (error) {
        console.log("error step 2", error);
      }
    } else {
      setConfirmModal(true);
    }
  };

  const onSubmit = async () => {
    setSubmitting(true);
    const dataForm1 = form1.getFieldsValue(true);
    const dataForm2 = form2.getFieldsValue(true);

    const payload = {
      ...dataForm1,
      ...dataForm2,
      products:
        dataForm2?.products?.length > 0
          ? dataForm2?.products?.map((p) => ({
              coProductId: p.coProductId || undefined,
              productId: p.productId,
              discountMode: p.discountMode,
              discountValue: Number(p.discountValue),
            }))
          : [],
      shops:
        dataForm2?.shops?.length > 0
          ? dataForm2?.shops?.map((s) => ({
              coShopId: s.coShopId || undefined,
              customerCompanyId: s.customerCompanyId,
              customerNo: s.customerNo,
              zone: s.zone,
              quotaAmount: s.quotaAmount,
              discountPct: s.discountPct,
              customerGroupName: s.customerGroupName,
              status: s.status ? "ACTIVE" : "INACTIVE",
            }))
          : [],
      company: profile?.company,
      ...(isCreate && { createdBy: profile?.firstname + " " + profile?.lastname }),
      updatedBy: profile?.firstname + " " + profile?.lastname,
      startDate: dataForm1?.startDate
        ? `${dataForm1?.startDate.format("YYYY-MM-DD")} ${dataForm1.startTime.format("HH:mm")}`
        : null,
      endDate: dataForm1?.endDate
        ? `${dataForm1?.endDate.format("YYYY-MM-DD")} ${dataForm1.endTime.format("HH:mm")}`
        : null,
      status: dataForm1?.status ? "ACTIVE" : "INACTIVE",
    };

    if (isCreate) {
      await createCoDiscoutList(payload).then((res) => {
        if (res.success) {
          messageApi.success("บันทึกสำเร็จ");
          navigate("/newDiscountCo/coDiscountList");
          fileRef.length > 0 && onSaveAttachment(res?.coId);
        }
      });
    } else {
      await updateCoDiscoutList(payload).then((res) => {
        if (res.success) {
          messageApi.success("บันทึกสำเร็จ");
          navigate("/newDiscountCo/coDiscountList");
          fileRef[0]?.originFileObj && onSaveAttachment(payload.coId);
        }
      });
      setTimeout(() => {
        setSubmitting(false);
      }, 1000);
    }
    fileRef.length === 0 && (await deleteAttachmentById({ coId: id, updateBy: payload.updatedBy }));
  };

  const onSaveAttachment = async (coId) => {
    if (fileRef.length > 0) {
      await createCoAttachment(coId, {
        file: fileRef[0].originFileObj as File,
        updateBy: profile?.firstname + " " + profile?.lastname,
      }).then((res) => res);
    }
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <Divider size='small' />
        <br />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            {renderStep()}
            <br />
            <Row justify='space-between' gutter={12}>
              <Col span={3}>
                {step > 0 && (
                  <Button typeButton='primary-light' title='ย้อนกลับ' onClick={onPrev} />
                )}
              </Col>
              <Col span={3}>
                <Button
                  typeButton='primary'
                  title={step === 3 ? "บันทึก" : "ถัดไป"}
                  onClick={onNext}
                />
              </Col>
            </Row>
          </>
        )}
      </CardContainer>
      {confirmModal && (
        <Modal
          centered
          open={confirmModal}
          closable={false}
          onCancel={() => setConfirmModal(false)}
          onOk={() => {
            setSubmitting(true);
            setTimeout(() => {
              onSubmit();
            }, 1000);
          }}
          okText='ยืนยัน'
          cancelText='ยกเลิก'
          confirmLoading={submitting}
          cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
        >
          <Text level={2}>ยืนยัน{isCreate ? "การสร้าง" : "การแก้ไข"}รายการส่วนลด</Text>
          <br />
          <Text color='Text3'>โปรดยืนยัน{isCreate ? "การสร้าง" : "การแก้ไข"}รายการส่วนลด</Text>
        </Modal>
      )}
    </>
  );
};

export const checkCoDuplicate = async (
  company,
  type,
  startDate,
  endDate,
  cusComIdList,
  productIdList?,
  coId?,
) => {
  const checkDup = await checkCoConflicts({
    company,
    type,
    startDate,
    endDate,
    customerCompanyIds: cusComIdList,
    productIds: productIdList,
    coId,
  }).then((res) => res);
  return checkDup;
};

export const onCheckDuplicate = async (checkDupList: any, form2: any) => {
  const form2Shops = form2.getFieldValue("shops") || [];
  if (checkDupList?.conflictCoList?.length > 0) {
    const mapShop = form2Shops.map((item: any) => {
      const findDup = checkDupList?.conflictCoList?.filter((p) =>
        p.shops.some(
          (dupShop: any) => `${dupShop.customerCompanyId}` === `${item.customerCompanyId}`,
        ),
      );
      if (findDup) {
        return {
          ...item,
          status: findDup.some((dup: any) => dup.blocking) ? false : item.status,
          isSwitchDisabled: findDup.some((dup: any) => dup.blocking),
          isDuplicate: findDup.length > 0,
          coDuplicateList: findDup.map((dup: any) => ({
            coId: dup.coId,
            code: dup.code,
            name: dup.name,
            type: dup.type,
            startDate: dup.startDate,
            endDate: dup.endDate,
            products: dup.products,
            creditMemoType: dup.creditMemoType,
            blocking: dup.blocking,
            shops: dup.shops.find(
              (dupShop: any) => `${dupShop.customerCompanyId}` === `${item.customerCompanyId}`,
            ),
          })),
        };
      } else {
        return {
          ...item,
        };
      }
    });
    form2.setFieldsValue({
      ...form2.getFieldsValue(true),
      shops: mapShop,
      searchShop: mapShop,
    });
  }
};
